import { differenceInSeconds, format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { useState, useEffect } from 'react';

import { UTC_TIME_FORMAT } from 'global/appConstants';
import { secondsToHms } from 'utils/helpers';

const useTimeDuration = (item: any) => {
  const [timeDuration, setTimeDuration] = useState<any>(null);

  useEffect(() => {
    const utcClockInTime = item?.clock_in_time_utc ? new Date(item.clock_in_time_utc) : null;

    if (!utcClockInTime) return;
    const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const localClockInTime = toZonedTime(format(new Date(utcClockInTime), UTC_TIME_FORMAT), localTimezone);

    if (item?.current_break) {
      const intervalDuration = differenceInSeconds(new Date(), localClockInTime);
      const HMS = secondsToHms(intervalDuration);

      setTimeDuration(HMS);
      return;
    }

    const timeInterval = setInterval(() => {
      const currentTime = new Date();
      const intervalDuration = differenceInSeconds(currentTime, localClockInTime);
      const HMS = secondsToHms(intervalDuration);

      setTimeDuration(HMS);
    }, 1000);

    return () => {
      clearInterval(timeInterval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return timeDuration;
};

export default useTimeDuration;
